module.exports = __webpack_public_path__ + "img/montserrat-vignette.f466bb51.jpg";